module.exports = __webpack_public_path__ + "img/btn_date.47b0c770.svg";